export default {
  VISA: 'VISA',
  AMEX: 'AMEX',
  Mastercard: 'Mastercard',
};



// WEBPACK FOOTER //
// ./src/views/skidata/components/paymentTypes.js